import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async get(includeAdmin) {
        try
        {          
            //includeAdmin is nullable
            const admin = includeAdmin?true:false
            const response = await axios.get(`Projects/summary/${admin}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                      
            return response
        }
        catch (error)
        {
            console.log('Project get api error')
            throw error
        }
    },
    async getById(projectId) {
        try
        {            
            const response = await axios.get(`Projects/${projectId}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                                 
            return response
        }
        catch (error)
        {
            console.log('Project getById api error')
            throw error
        }
    },
    async getProjectReport(projectId, fiscalYear) {
        try
        {            
            const response = await axios.get(`Projects/${projectId}/xls/${fiscalYear}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.projects
                }
            })                                 
            return response
        }
        catch (error)
        {
            console.log('Project getProjectReport api error')
            throw error
        }
    },    
    async getByIdAndFY(projectId, fiscalYear) {
        try
        {            
            const response = await axios.get(`Projects/${projectId}/details/${fiscalYear}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                                 
            return response
        }
        catch (error)
        {
            console.log('Project getByIdAndFY api error')
            throw error
        }
    },
    async addProject(data) {
        try
        {            
            const response = await axios.post(`Projects/add`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                               
            return response
        }
        catch (error)
        {
            console.log('Projects addProject api error')
            throw error
        }
    },
    async updateProject(data) {
        try
        {            
            const response = await axios.post(`Projects/update`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                               
            return response
        }
        catch (error)
        {
            console.log('Projects updateProject api error')
            throw error
        }
    },
    async getProjectTask(projectTaskId) {
        try{            
            const response = await axios.get(`Projects/task/${projectTaskId}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                                          
            return response
        }
        catch (error)
        {
            console.log('Project getProjectTask api error')
            throw error
        }
    },
    async addProjectTask(data) {
        try
        {            
            const response = await axios.post(`Projects/task/add`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                                          
            return response
        }
        catch (error)
        {
            console.log('Project addProjectTask api error')
            throw error
        }
    },
    async updateProjectTask(data) {
        try
        {            
            const response = await axios.post(`Projects/task/update`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })                                          
            return response
        }
        catch (error)
        {
            console.log('Project updateProjectTask api error')
            throw error
        }
    },
    async deleteProjectTask(data) {
        try{            
            const response = await axios.post(`Projects/task/delete`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })         
            return response
        }catch (error){
            console.log('Project deleteProjectTask api error')
            throw error
        }
    },  
    async deleteProject(data) {
        try{            
            const response = await axios.post(`Projects/delete`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })         
            return response
        }catch (error){
            console.log('Project deleteProject api error')
            throw error
        }
    },  
    async updateStatus(data) {
        try{            
            const response = await axios.post(`Projects/delete`, {item: data}, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })         
            return response
        }catch (error){
            console.log('Project updateStatus api error')
            throw error
        }
    },
}